// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"LoadingSpinner_spinnerContainer__aBtqz"};